<!--
    회원가입 (신청)

    중복체크(op=C) & 가입신청(op=I) /public/proc_iv/N_BUBJOIN_UPD


-->
<template>
  <div class="content member_wrap" >

    <c회원선택 ref="selectCust" @select="selectCust" />

    <s-location title="회원가입"/>

    <!-- <h1>회원 가입</h1> -->

    <div id="doViewNormal">

      <table class="tbl01 view01">
        <thead>
          <tr>
            <th class="th_join">구분</th>
            <th>내용</th>
          </tr>
        </thead>
        <tr>
          <th class="req">회원구분</th>
          <td>
            <!-- <input type="radio" v-model="item.jointype" value="P" name="freetype" id="rfree_1" checked="checked"/> <label for="rfree_1">개인사무실</label> -->
            <input type="radio" v-model="item.jointype" value="B" name="freetype" id="rfree_2" checked="checked"/> <label for="rfree_2">법무법인</label>
            <input type="radio" v-model="item.jointype" value="C" name="freetype" id="rfree_3" checked="checked"/> <label for="rfree_3">법무법인 유한</label>
            <br class="mobile"/>
            <input type="radio" v-model="item.jointype" value="J" name="freetype" id="rfree_4" checked="checked"/> <label for="rfree_4">공동법률사무소</label>
              <span id="id_comment">
                <em class="icon_info" >i</em>
                <div class="toggleInfo">
                  <p class="tit">공동법률사무소</p>
                  <div class="cont">
                    공동법률사무소는 대한변호사협회 회칙 제39조에 의거하여 본회 및 <br/>
                    대한변호사협회에 '공동법률사무소 설립신고서'를 제출하고, 설립 비용을<br/>
                    납부하여 정식으로 등록된 경우에만 해당됩니다<font class="blue01" style="cursor: pointer" @click="openSite">(관련 안내 페이지 바로가기)</font>.
                  </div>
                </div>
              </span>

          </td>
        </tr>
<!-- [회원구분] : 공동법률사무소 -->
        <tr v-if="item.jointype == 'J'">
          <th class="req">사무소명</th>
          <td>
            <!-- <input type="text" v-model="item.flnm"/> -->
            <!-- <i-btn class="btn blue01 xs" @click="doJoin('C')">중복확인</i-btn> -->
            <!-- <i-btn class="btn blue01 xs" @click="doJoin('C')">검색</i-btn> -->
            <input type="text" v-model="item.flnm" @keydown.enter="$refs.selectCust.open('J', item.flnm, '', 'N', 'Y')" v-tooltip="'사무소명을 입력해 주세요'"/>
            <i-btn class="btn blue01 xs" @click="$refs.selectCust.open('J', item.flnm, '', 'N', 'JD')" >사무소검색</i-btn>
          </td>
        </tr>
<!-- [회원구분] : 법무법인, 법무법인 유한 -->
      <template v-else>
        <tr>
          <th class="req">인가번호</th>
          <td> <input type="text" v-model="item.ingano" v-tooltip="'숫자로 입력해 주세요'" placeholder="숫자로 입력" />
            <div class="comment_gray">
              인가번호란 법무부에서 부여한 법인설립 번호로서 법인설립 인가서에 표시되어 있음. <br class="mobile"/> ( 입력예: 327(O), 00327(X) )
            </div>
          </td>
        </tr>
        <tr>
          <th class="req">인가일</th>
          <td>
            <i-input-date input-class="w_inputno" title="인가일" v-model="item.ingadt" />
            <i-btn class="btn blue01 xs" @click="doJoin('C')">확인</i-btn>
          </td>
        </tr>
        <tr>
          <th class="req">법인명</th>
          <td>
            <input type="text" v-model="item.flnm" disabled/><!-- 법인명 입력불가. [인가번호]와 [인가일]로 중복체크 -->
          </td>
        </tr>
      </template>
        <tr>
          <th>사무실 주소</th>
          <td>
              <input type="text" disabled class="w100p mt5" v-model="item.addr1" />
              <input type="text" disabled class="w100p mt5" v-model="item.addr2"/>
          </td>
        </tr>
<!--
        <tr>
          <th class="req">등록번호</th>
          <td>
            <input type="text" v-model="item.membno" />
            <i-btn class="btn blue01 xs" @click="doJoin('C')">중복확인</i-btn>
            <div class="comment_gray rline mt5">
            	  <li v-if="item.jointype == 'P'">등록번호란 대한변호사협회에서 부여한 변호사자격 등록번호로서 변호사 신분증에 표시되어 있음.<Br/>  ( 입력예: 03470(O), 3470(X) )</li>
                <li v-else >등록번호란 법무부에서 부여한 법인설립 인가번호로서 법인설립 인가서에 표시되어 있음. <br/> ( 입력예: 327(O), 00327(X) )</li>
            </div>
          </td>
        </tr>
-->
        <tr>
          <th class="req">아이디</th>
          <td>
            <input type="text" v-model="item.id" maxlength="16"/>
            <div class="input-error" v-if="inputError.id">{{ inputError.id }}</div>
          </td>
        </tr>
        <tr>
          <th class="req">비밀번호</th>
          <td>
            <input type="password" v-model="item.pswd" maxlength="16"/>
            <div class="input-error" v-if="inputError.pswd">{{ inputError.pswd }}</div>
          </td>
        </tr>
        <tr>
          <th class="req">비밀번호 재확인</th>
          <td>
            <input type="password" v-model="item.pswd_check" maxlength="16"/>
            <div class="input-error" v-if="inputError.pswd_check">{{ inputError.pswd_check }}</div>
          </td>
        </tr>
        <tr>
          <th class="req">대표변호사 성명</th>
          <td> <input type="text" v-model="item.reqname"/></td>
        </tr>
        <tr>
          <th class="req">생년월일</th>
          <td>
            <i-input-date input-class="w_inputno" title=" 신청인생년월일" v-model="item.reqbirthday" />
          </td>
        </tr>
<!--
        <tr>
          <th class="req">신청인 자격</th>
          <td>
            <span v-for="code in code.REQAUTH" :key="code.value">
            <input
              type="radio"
              v-model="item.reqauth"
              :value="code.value"
              :id="code.value"
              class="sch_input"
            />
            <label :for="code.value">{{ code.text}}</label>
            </span>
             <i-input
               v-if="item.reqauth == 'etc'"
               v-model="item.reqauth_etc" class="ml-1 w100"/>
          </td>
        </tr>
  -->
        <tr>
          <th class="req">연락처</th>
          <td> <input type="text" v-model="item.reqtel"/></td>
        </tr>
        <tr>
          <th class="req">대표변호사 신분증 사본<br/>(파일첨부)</th>
          <td>
            <i-fileupload name="file1" ref="file1" v-model="file1"
            :action="$api + '/public/attach'"
            autoUpload required
            kind="memberjoin"
            :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
            @done="file=>item.attachid = file.uuid"
            >

              <template v-slot:dropArea="{isDropActive, files}">
                <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                  Drag And Drop
                </div>
              </template>

              <template v-slot:uploadFile="{file, remove}">
                {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
                <i-btn class="btn" @click.prevent="remove(file);item.attachid=null" :key="file.id">취소</i-btn>
              </template>

              <button v-if="!file1 || !file1.name"
                class="btn gray01 outline btn_filesel">
                파일선택
              </button>

              &nbsp;
            </i-fileupload>
            <div class="mt10">
              ※ 신분증 사본을 첨부해 주세요. (jpg,gif,png,pdf)
            </div>
          </td>
        </tr>
<!-- [첨부파일] 사업자등록증 사본 -->
        <tr v-if="item.jointype == 'J'">
          <th class="req">사업자등록증 사본<br/>(파일첨부)</th>
          <td>
            <i-fileupload name="file2" ref="file2" v-model="file2"
            :action="$api + '/public/attach'"
            autoUpload required
            kind="memberjoin"
            :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
            @done="file=>item.attachid2 = file.uuid"
            >

              <template v-slot:dropArea="{isDropActive, files}">
                <div v-if="$mq != 'mobile' && !file2.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                  Drag And Drop
                </div>
              </template>

              <template v-slot:uploadFile="{file, remove}">
                {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
                <i-btn class="btn" @click.prevent="remove(file);item.attachid2=null" :key="file.id">취소</i-btn>
              </template>

              <button v-if="!file2 || !file2.name"
                class="btn gray01 outline btn_filesel">
                파일선택
              </button>

              &nbsp;
            </i-fileupload>
            <div class="mt10">
              ※ 사업자등록증 사본을 첨부해 주세요. (jpg,gif,png,pdf)
            </div>
          </td>
        </tr>
      </table>
      <div class="comment_gray rline mt5">
          <li v-if="item.jointype == 'P'">개인회원은 본회 홈페이지에 가입된 아이디 이외에 인터넷 경유업무프로그램 전용 아이디를 추가로 부여받아 사용할 수 있음.<br/>
              - 가입 및 사이트문의 : 정통팀(6200-6282)<br/>
              - 기타문의 : 재무팀(6200-6225)	</li>
          <li v-else>가입 관련 문의 : 본회 사무국 재무팀(6200-6225, 6277)</li>
      </div>

      <div class="btn_group print mt30">
          <router-link to="/buy/buy_ok" class="btn gray01 outline mr30">취소</router-link>
          <a class="btn gray01" @click="doJoin('I')">신청하기</a>
      </div>

    </div>
  </div>

</template>

<script>
let ui
import _config from '../../plugins/config'
export default {
  components: {
    "c회원선택"     : require('@/components/c회원선택.vue').default,
  },
  data () {
    return {
      item : {
          jointype : ''
        , flnm : ''
        , membno : ''
        , membclsf : ''
        , id : ''
        , pswd : ''
        , pswd_check : ''
        , addr1 : ''
        , addr2 : ''
        , email : ''
        , ingano      : ''
        , ingadt      : ''
        , reqname     : ''
        , reqbirthday : ''
        //, reqauth     : '' // 신청인 자격 : 19.12.13 삭제
        //, reqauth_etc : ''
        , reqtel      : ''
        , attachid    : ''
        , attachid2   : '' // 공동법률사무소로 가입 시, 사업자등록증 사본 첨부파일
      },
      inputError: {id : '',  pswd : '', pswd_check : ''},
      file1 : {},
      file2 : {},
      code: {},
    }
  },
  watch: {
    "item.jointype"(v) { // [회원구분] 변경 시, 중복조회한 정보 날리기
      this.item.flnm   = ''
      this.item.membclsf = ''
      this.item.membno = ''
      this.item.addr1  = ''
      this.item.addr2 = ''
      this.item.ingano = ''
      this.item.ingadt = ''
    },
    "item.id"(v) { this.inputError.id = this.checkInput('id', v) },
    "item.pswd"(v) { this.inputError.pswd = this.checkInput('pswd', v) },
    "item.pswd_check"(v) { this.inputError.pswd_check = this.checkInput('pswd_check', v) },
  },
  created() {
    ui = this.$ui

    // 공통 코드 로드
/*     ui.codeLoad("REQAUTH", code => {
      this.code = code
    }); */
  },
  mounted () {
  },
  methods: {

// "1pt 2px 3em 4px".replaceAll("\\d+(?=px)", "*") ==
// "1pt *px 3em *px"

// 숫자2개 필수이면서 영숫자 8~12자
// "^(?=.*\\d.*\\d)[\\da-zA-Z]{8,12}$"

// 최소 8자리에 숫자, 문자, 특수문자 각각 1개 이상 포함
// "^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$"

// 최소 8자리에 대문자 1자리 소문자 한자리 숫자 한자리
// "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$"

// 최소 8자리에 대문자 1자리 소문자 1자리 숫자 1자리 특수문자 1자리
// "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}"

    checkInput(kind, v) {
      if (_.isEmpty(v)) return ""

      switch(kind) {
        case "id":
          if (!/^[\da-zA-Z]{4,16}$/.test(v)) return "4~16자 영문 대 소문자, 숫자를 입력해 주세요"
          return ""
        case "pswd":
          if (!/^[\da-zA-Z$@$!%*?&\\.]{8,16}$/.test(v)) return "8~16자 영문 대 소문자, 숫자 2자 이상, 특수문자 1자 이상을 입력해 주세요"
          if (!/\d/.test(v)) return "숫자 1자 이상을 입력해 주세요"
          if (!/[$@$!%*?&\\.]/.test(v)) return "특수문자 1자 이상을 입력해 주세요"
          return ""
        case "pswd_check":
          if (this.item.pswd != v) return "비밀번호와 비밀번호 확인이 일치하지 않습니다."
          return ""
      }
    },

    selectCust(item) { // 공동법률사무소 검색결과

      // console.log("공동 검색 결과 item = ", item)

      // knm: "신앤유 공동법률사무소"
      // membno: "113  "
      // hnm: ""
      // bidt: ""
      // all_addr: "서울 마포구 상암동1593 우리기술빌딩 11층"
      // officezipaddr: "서울 마포구 상암동"
      // addr: "1593 우리기술빌딩 11층"
      // membclsf: "J"
      // officegbn: "J"
      // officeno: "113       "
      // officename: "신앤유 공동법률사무소"
      // membnm: "신앤유 공동법률사무소"

      this.item.flnm   = item.membnm
      this.item.membclsf = item.membclsf
      this.item.membno = item.membno
      this.item.addr1  = item.officezipaddr
      this.item.addr2  = item.addr

    },
    doJoin(op){

      // 회원가입 (개인) 테스트 용 회원번호 조회
      // select membno  FROM    [SIDB].dbo.tv_memb

      if(op == 'C'){ // 중복체크
        ui.httpPost("/public/proc_iv/N_BUBJOIN_UPD_V01",
          {
            ...this.item,
            flnm    : this.item.flnm.replace(/\s+/g, ""),
            ingadt  : this.item.ingadt.replace(/-/g, ""),
            accflag : op,
          }, ret => {
            const {msg, status, membno, flnm, addr1,addr2} = ret.data.rs1[0];
            this.$ui.notify(msg)
            if (status == '0') {
              this.item.membno = membno
              this.item.flnm  = flnm
              this.item.addr1 = addr1
              this.item.addr2 = addr2
            }
          }
        )


      }else if(op == 'I'){

        ui.httpPost("/public/proc_iv/N_BUBJOIN_UPD_V01",
          {
            ...this.item
            , accflag  : op
          }, ret => {
            console.log("회원가입완료")

            const {msg, status} = ret.data.rs1[0];
            this.$ui.notify(msg);
            if (status == '0') {
              console.log("회원가입완료")
              this.$router.push(_config.LOGIN_PATH)
            }

          }
        )
      }

    },
    openSite(){
      window.open("https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/online/OnlineDocumentLawFirm", '_blank')
    },
  }
}
</script>
<style>

  .comment_gray { border:2px solid #999; }
  table .comment_gray { border:none; padding:10px; }
  table .th_join { width:180px !important; }


#id_comment:hover .toggleInfo { display: inline-block; margin:18px 0 0 -200px;}
.input-error { color: red; margin-top: 7px;  }
  @media screen and (max-width:640px){
    table .th_join { width:110px !important; }
    #id_comment:hover .toggleInfo {  margin: 20px 0 0 0;}
    .comment_gray  { padding:4px;}
  }
</style>
